class SlideMenu {
    constructor() {
        const slideMenu = $(".slidemenu")
        const slideMenuLeftArrow = $(".slidemenu-arr-l")
        const slideMenuRightArrow = $(".slidemenu-arr-r")
        const viewportHeight = $(window).height() - 119

        $(".header-index").css("min-height", viewportHeight)

        slideMenuRightArrow.click((event: MouseEvent) => {
            event.preventDefault()
            slideMenu.animate({ scrollLeft: "+=190px" }, "slow")
        })

        slideMenuLeftArrow.click((event: MouseEvent) => {
            event.preventDefault()
            slideMenu.animate({ scrollLeft: "-=190px" }, "slow")
        })

        slideMenu.on("scroll", () => {
            const getScroll = slideMenu.get(0).scrollLeft
            const maxScrollLeft = slideMenu.get(0).scrollWidth - slideMenu.get(0).clientWidth

            if (getScroll >= maxScrollLeft) {
                slideMenuRightArrow.hide()
            } else {
                slideMenuRightArrow.show()
            }

            if (getScroll >= 1) {
                slideMenuLeftArrow.show()
            } else {
                slideMenuLeftArrow.hide()
            }
        })
    }
}

new SlideMenu()
